import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popover,
} from "@mui/material";
import axios from "axios";
import { ROLES, UPDATE_USER_PREFERENCE, USER_PREFERENCE } from "../constants/constant";
import { getDataWAuth } from "../utils/api-service";
import ToastMessageFunction from "./toast-message-function";
import { checkErrorMsg } from "../utils/utils";

const roleMapping = {
  BP: "Business Processor",
  BKP: "Bank Personal",
  BN_ADMIN: "BN ADMIN",
  BN_USER: "BN USER",
};

const countryMapping = {
  FR: "France",
  GB: "UK",
  DE: "Germany",
  IE: "Ireland",
  PL: "Poland",
  PT: "Portugal",
  ES: "Spain",
  IT: "Italy",
  JD: "JDWIN",
};

const UserProfileTable = ({ userPreference }) => {
  const roles =
    userPreference && userPreference.userProfile
      ? Object.keys(userPreference.userProfile).sort()
      : [];
  const [selectedRole, setSelectedRole] = useState(userPreference.preferedRole);
  const [selectedCountry, setSelectedCountry] = useState(
    userPreference.preferedCountry
  );
  const [availableCountries, setAvailableCountries] = useState(
    userPreference.userProfile[selectedRole]?.sort((a, b) =>
      countryMapping[a].localeCompare(countryMapping[b])
    ) || []
  );
  const [roleAnchorEl, setRoleAnchorEl] = useState(null);
  const toastManager = ToastMessageFunction();

  const commonTextStyle = {
    fontSize: "14px",
    fontWeight: 600,
    color: "#333",
  };

  useEffect(() => {
    const updateAvailableCountries = () => {
      if (selectedRole === "BKP" || selectedRole === "ADMIN") {
        setSelectedCountry(null);
        setAvailableCountries([]);
      } else {
        const countries =
          userPreference.userProfile[selectedRole]?.sort((a, b) =>
            countryMapping[a].localeCompare(countryMapping[b])
          ) || [];
        setAvailableCountries(countries);
        if (userPreference.userProfile?.role?.associatedCountry) {
          setSelectedCountry(userPreference.userProfile.role.associatedCountry);
        }
      }
    };
    updateAvailableCountries();
  }, [selectedRole, userPreference]);

  const getOktaToken = () => {
    const oktaTokenStorage = localStorage.getItem("okta-token-storage");
    if (oktaTokenStorage) {
      const tokenData = JSON.parse(oktaTokenStorage);
      return tokenData.accessToken.accessToken;
    }
    return null;
  };

  const handleSaveClick = async (role, country) => {
    const token = getOktaToken();
    try {
      const response = await axios.post(UPDATE_USER_PREFERENCE, null, {
        params: {
          preferedRole: role,
          preferedCountry:
            role === "BKP" || role === "ADMIN"
              ? ""
              : country,
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        window.location.href = "/";
        getDataWAuth(USER_PREFERENCE);
      }
      else {
        showToast((response.response.data.message), "error");
     }
    } catch (error) {
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else
      showToast((error.response.data.message), "error");
    }
  };

  const handleRoleClick = (event, role, country) => {
    setSelectedRole(role);
    setRoleAnchorEl(event.currentTarget);
    if(role === "BKP" || role === "ADMIN" || role === ROLES.BN_ADMIN || role === ROLES.JDU_ADMIN || role === ROLES.BN_USER) {
      setSelectedCountry(null);
      handleSaveClick(role, "");
      return;
    }
  };

  const handleCountryClick = (country, role) => {
    setSelectedCountry(country);
    handleSaveClick(selectedRole, country);
  };

  const handlePopoverClose = () => {
    setRoleAnchorEl(null);
  };

  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager]
  );

  return (
    <Paper>
       {toastManager.toast}
      <Box>
        {roles.map((role) => (
          <Box key={role}>
            <ListItemButton
              sx={{
                pl: 5,
                backgroundColor: selectedRole === role ? "green" : "white",
                color: selectedRole === role ? "white" : "black",
              }}
              onClick={(event) => handleRoleClick(event, role)}
            >
              <ListItemText
                primary={roleMapping[role] || role}
                primaryTypographyProps={{
                  ...commonTextStyle,
                  color: selectedRole === role ? "white" : "#333",
                }}
              />
            </ListItemButton>
            {selectedRole !== "BKP" && selectedRole !== "ADMIN" && selectedRole !== "BN_ADMIN" &&selectedRole !== "BN_USER" &&   (
              <Popover
                sx={{ mt: -12, ml: -30 }}
                open={Boolean(roleAnchorEl) && selectedRole === role}
                anchorEl={roleAnchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Box sx={{ p: 1 }}>
                  <List>
                    {availableCountries.map((country) => (
                      <ListItemButton
                        key={country}
                        sx={{
                          pl: 5,
                          backgroundColor:
                            selectedCountry === country ? "green" : "white",
                          color:
                            selectedCountry === country ? "white" : "black",
                        }}
                        onClick={() => handleCountryClick(country)}
                      >
                        <ListItemText
                          primary={countryMapping[country] || country}
                          primaryTypographyProps={{
                            ...commonTextStyle,
                            color:
                              selectedCountry === country ? "white" : "#333",
                          }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Box>
              </Popover>
            )}
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default UserProfileTable;